import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { categoriesStyles } from 'components/ElementsTree/styles/categoriesPaneStyles'
import {
    categoryBackgroundImage,
    shortedCategoryData,
} from 'components/ElementsTree/utils'
import { CategoryPanel, ProfessionalDisciplineInner } from 'models/category'
import React, { ChangeEvent } from 'react'
import DisciplineSelector from './DisciplineSelector'

interface CategoryPaneProps {
    /** Callback invoked when a category is selected. */
    handleCategorySelection: (
        dataCategory: CategoryPanel,
        dataDiscipline: ProfessionalDisciplineInner
    ) => void
    /** list of all discipline data  */
    disciplineData: ProfessionalDisciplineInner[]

    /** list of all categories data  */
    categoriesData: CategoryPanel[]

    /** selected category object  */
    selectedCategory?: CategoryPanel | null

    /** selected discipline object  */
    selectedDiscipline?: ProfessionalDisciplineInner | null

    /** default value of selected category object  */
    defaultCategory?: CategoryPanel

    /** selected object of project element filter*/
    selectedElementFilterValue?: string

    /** Callback invoked when the collapse icon clicked from category pane */
    handleCollapseLeftPanel?: VoidFunction

    /** custom react node for collapse icon. */
    collapseIcon?: React.ReactNode
}
const CategoryPane = ({
    handleCategorySelection,
    disciplineData,
    categoriesData,
    selectedCategory,
    selectedDiscipline,
    selectedElementFilterValue,
    handleCollapseLeftPanel,
    collapseIcon,
}: CategoryPaneProps) => {
    const classes = categoriesStyles()

    const handleCategoryChange = React.useCallback(
        (
            dataCategory: CategoryPanel,
            dataDiscipline: ProfessionalDisciplineInner
        ) => {
            if (dataCategory && dataDiscipline) {
                handleCategorySelection(dataCategory, dataDiscipline)
            }
        },
        [handleCategorySelection]
    )

    const handleDisciplineChange = (
        _: ChangeEvent<{}>,
        values: ProfessionalDisciplineInner
    ) => {
        handleCategorySelection(values.categories[0], values)
    }

    React.useEffect(() => {
        if (!selectedCategory && !selectedDiscipline && disciplineData[0]) {
            if (selectedElementFilterValue === 'Added to Work Results') {
                handleCategoryChange(
                    {
                        name: 'Work Results',
                        id: '1f689538-1896-41a1-b66b-dd41f71a595a',
                    },
                    disciplineData[0]
                )
            } else {
                handleCategoryChange(
                    {
                        name: 'All Categories',
                        id: 'all',
                    },
                    disciplineData[0]
                )
            }
        }
    }, [
        disciplineData,
        categoriesData,
        handleCategoryChange,
        selectedCategory,
        selectedDiscipline,
        selectedElementFilterValue,
    ])

    return (
        <GridContainer
            data-testid="categoryContainer"
            className={classes.categoryContainerLeftPane}
        >
            {selectedDiscipline && (
                <DisciplineSelector
                    disciplineData={disciplineData}
                    collapseIcon={collapseIcon as React.ReactNode}
                    handleDisciplineChange={handleDisciplineChange}
                    selectedDiscipline={selectedDiscipline}
                />
            )}
            <GridItem
                data-testid="AllCategoryButton"
                className={clsx(
                    classes.categoryItemLeftPane,
                    selectedCategory?.name === 'All Categories' &&
                        classes.activeCategoryItem
                )}
                onClick={() => {
                    if (selectedCategory?.name !== 'All Categories') {
                        handleCategoryChange(
                            {
                                name: 'All Categories',
                                id: 'all',
                            },
                            disciplineData[0]
                        )
                    }
                }}
            >
                <Typography
                    component="span"
                    className={
                        selectedCategory?.name === 'All Categories'
                            ? classes.categoryTextActive
                            : classes.categoryText
                    }
                >
                    All Categories
                </Typography>
            </GridItem>

            <div className={classes.categoriesDiv}>
                {selectedDiscipline &&
                    shortedCategoryData(categoriesData)?.map(
                        (item: CategoryPanel, index: number) => {
                            return (
                                <GridItem
                                    data-testid="CategoryItem"
                                    className={clsx(
                                        classes.categoryItemLeftPane,
                                        selectedCategory?.name === item?.name &&
                                            classes.activeCategoryItem
                                    )}
                                    key={index}
                                    onClick={() =>
                                        handleCategoryChange(
                                            item,
                                            selectedDiscipline
                                        )
                                    }
                                >
                                    <div
                                        style={{
                                            backgroundImage: categoryBackgroundImage(
                                                item
                                            ),
                                        }}
                                        className={classes.categoryImage}
                                    ></div>
                                    <Typography
                                        className={
                                            selectedCategory?.name ===
                                            item?.name
                                                ? classes.categoryTextActive
                                                : classes.categoryText
                                        }
                                    >
                                        {item.name}
                                    </Typography>
                                </GridItem>
                            )
                        }
                    )}
            </div>
        </GridContainer>
    )
}

export default CategoryPane
